module.exports = __webpack_public_path__ + "assets/img/map.dea674ae.png";